module.exports = __webpack_public_path__ + "img/player.ea08c0eb.png";